import { createSlice } from "@reduxjs/toolkit";

const initialState:UINotasServico = {
    notas: [],
    competencias: [],
    atualizar: false,
    primeiro_loading: true,
    notas_selecionadas: []
}
export interface UINotasServico {
    notas: any[]
    competencias: string[]
    atualizar: boolean
    primeiro_loading: boolean
    notas_selecionadas: any[]
}

export const notasServicoSlice = createSlice({
    name: "uiNotasServico",
    initialState,
    reducers: {
        atualizar: (state, action) => {
            state.notas = action.payload.notas
            state.competencias = action.payload.competencias
        },
        alterarStatusAtualizar: (state, action) => {
            state.atualizar = action.payload.atualizar
        },
        alterarStatusPrimeiroLoading: (state, action) => {
            state.primeiro_loading = action.payload.primeiro_loading
        },
        selecionarNotas: (state, action) => {
            state.notas_selecionadas = action.payload.notas_selecionadas
        },
    }
})

export const { atualizar, alterarStatusAtualizar, alterarStatusPrimeiroLoading, selecionarNotas } = notasServicoSlice.actions

export default notasServicoSlice.reducer
